<template>
  <div class="animated fadeIn">
    <div class="card card-yellow">
      <div class="card-body">
        <div class="row mb-2">
          <div class="col-12">
            <button type="button" class="btn btn-primary button-add pull-right" @click="showModal()">{{$t('NEW')}}</button>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12  table-responsive">
              <table class="table table-bordered table-striped table-hover table-sm table-logoped">
                <thead>
                  <tr>
                    <th>
                      {{$t('WORKTYPE')}}
                    </th>
                    <th>{{$t('ACTION')}}</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="item in response.root">
                    <tr :key="item.workTypeId" aria-rowindex="1" class=" table-ellipsis">
                      <td>{{item.workType}}</td>
                      <td>
                        <button type="button" class="btn button-edit mr-2"  @click="showModal(item)">{{$t('EDIT')}}</button>
                        <button type="button" class="btn button-dlt" @click="deleteRow(item.workTypeId)">{{$t('DELETE')}}</button>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
              <nav>
                <pagination v-bind:totalCount="response.totalCount" v-model="pagination" v-on:reload="getData"></pagination>
              </nav>
          </div>
        </div>
      </div>
    </div>
    <b-modal ref="formmodal" :title="$t('WORKTYPEFORM')" ok-title="submit" hide-footer no-close-on-backdrop>
      <div class="d-block">
        <worktypeform v-bind:formData="formData" v-bind:formError="formError"></worktypeform>
      </div>
      <div class="text-right">
        <b-btn class="mr-2 button-cancel" @click="hideModal()">{{$t('CANCEL')}}</b-btn>
        <b-btn class="button-save" @click="submitData(formData)">{{$t('SAVE')}}</b-btn>
      </div>
    </b-modal>
  </div>
</template>

<script>
import
{
  mapActions,
  mapGetters
}
from 'vuex'
import Api from '@/api/worktype/WorkType'
import WorkTypeForm from './Form'

export default
{
  name: 'WorkType',
  components:
  {
    worktypeform: WorkTypeForm
  },
  data: function()
  {
    return {
      response:
      {},
      formError:
      {},
      formData:
      {
        workType: ''
      },
      pagination:
      {
        query: '',
        currentPage: 1,
        limit: 25,
        searchTimeout: false
      }
    }
  },
  created()
  {
    var me = this;
    me.getData();
  },
  methods:
  {
    async getData()
    {
      var me = this;
      try
      {
        var data = await Api.selectRow(me.getParams);
        if (data.error && data.error == true)
        {
          me.$notify.notice(data);
          me.loading = false;
          return;
        }

        me.response = data;
      }
      catch (e)
      {
        me.$notify.notice(e);
      }
    },
    async deleteRow(id)
    {
      var me = this;
      try
      {
        me.$store.commit('setModalAlert',
        {
          text: me.$i18n.t('AREYOUSHURE'),
          btnAction: async function()
          {
            var data = await Api.deleteRow(
            {
              id: id
            });
            me.$notify.notice(data);
            await me.getData();
          }
        })
      }
      catch (e)
      {
        me.$notify.notice(e);
      }
    },
    showModal(item)
    {
      var me = this;
      if (typeof item != 'undefined') me.formData = item;
      this.$refs.formmodal.show()
    },
    async submitData(item)
    {
      var me = this;
      try
      {
        if (typeof item.workTypeId != 'undefined')
        {
          item.id = item.workTypeId;
          delete(item.workTypeId);
        }

        var data = await Api.submitData(item);
        if (data.error)
        {
          me.$notify.notice(data);
          me.formError = data;
        }
        else
        {
          me.$notify.notice(data);
          me.hideModal();
          await me.getData();
        }
      }
      catch (e)
      {
        me.$notify.notice(e);
      }
    },
    hideModal()
    {
      var me = this;
      this.$refs.formmodal.hide();

      me.formData = {
        name: ''
      }
    }
  },
  watch:
  {
    'pagination.limit': function(val)
    {
      var me = this;
      me.getData();
    },
    'pagination.currentPage': function(val)
    {
      var me = this;
      me.getData();
    },
    'pagination.query': function(val)
    {
      var me = this;

      if (me.pagination.searchTimeout != false) clearTimeout(me.pagination.searchTimeout);

      me.pagination.searchTimeout = setTimeout(function()
      {
        me.getData();
        me.pagination.searchTimeout = false;
      }, 300);
    }
  },
  computed:
  {
    getParams: function()
    {
      var me = this;
      var data = Object.assign(
      {}, me.pagination,
      {});
      data.start = (data.currentPage - 1) * data.limit;
      return data;
    }
  }
}
</script>
